<template>
  <div class="address-pop" :style="{'padding-top': position == 'right' ? `${$store.state.statusBarHeight}px`: 0 }">
    <div class="address-pop-header">
      <svg-icon className="icon-svg back-icon" :xlink="$globalIcon.backIcon" @click="close" v-if="iconArrow"/>
      <span>{{ title }}</span>
      <svg-icon v-if="!iconArrow" className="icon-svg close-icon" :xlink="$globalIcon.closeIconNew" @click="close"/>
    </div>
    <div class="address-pop-body">
      <AddrSelect :title="title" :storeId="storeId" theme="grey" :position="position" @success="addressSucess"/>
    </div>
  </div>
</template>

<script>
import AddrSelect from '@/components/addrSelect'

export default {
  props: {
    title: {
      type: String,
      default: '配送至'
    },
    iconArrow: {
      type: Boolean,
      default: false
    },
    storeId: {
      type: [String,Number],
      default: ''
    },
    position: {
      type: String,
      default: 'bottom'
    }
  },
  components: {
    AddrSelect,
  },
  methods: {
    addressSucess(){
      this.$emit('success')
    },
    close(){
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.address-pop{
  height: 100%;
  box-sizing: border-box;
}

.address-pop-header{
  position: relative;
  height: .88rem;
  display: flex;
  justify-content: center;
  align-items: center;
  > span{
    font-size: .34rem;
  }
  .icon-svg{
    width: .3rem;
  }
  .back-icon{
    position: absolute;
    top: .1rem;
    left: .3rem;
  }
  .close-icon{
    position: absolute;
    right: .3rem;
    top: .2rem;
  }
}

.address-pop-body{
  padding: 0 .32rem;
  height: calc(100% - 2.2rem);
  overflow: hidden;
}

</style>